
    <template>
      <section class="content element-doc">
        <h2 id="qia-pian"><a class="header-anchor" href="#qia-pian">¶</a> 卡片</h2>
<p>基础属性和使用方法参考 <a href="https://element.eleme.cn/#/zh-CN/component/card">element-ui </a> <code>el-card</code> 组件文档</p>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa">¶</a> 基础用法</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;sh-card&gt;
    &lt;div slot=&quot;header&quot;&gt;
      &lt;span&gt;卡片标题&lt;/span&gt;
      &lt;el-button style=&quot;float: right; padding: 3px 0&quot; type=&quot;text&quot;&gt;操作按钮&lt;/el-button&gt;
    &lt;/div&gt;
    &lt;div&gt;
      内容
    &lt;/div&gt;
  &lt;/sh-card&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {}
&lt;/script&gt;
&lt;style&gt;&lt;/style&gt;
</code></pre></template></demo-block><h3 id="shu-xing"><a class="header-anchor" href="#shu-xing">¶</a> 属性</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>header</td>
<td>设置头部内容</td>
<td>string</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>body-style</td>
<td>设置 body 的样式</td>
<td>object</td>
<td>-</td>
<td>{padding:'10px}</td>
</tr>
<tr>
<td>shadow</td>
<td>设置阴影显示时机</td>
<td>string</td>
<td>always / hover / never</td>
<td>hover</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('sh-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("卡片标题")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","padding":"3px 0"},attrs:{"type":"text"}},[_vm._v("操作按钮")])],1),_vm._v(" "),_c('div',[_vm._v("\n      内容\n    ")])])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  